// Detecta EVOLUCIONES de palabras: transformar una palabra válida en otra más compleja.
// Ej: CASA -> CASAS, ORDEN -> DESORDEN, CREAR -> CREADOR.
import { normalizeForLookup, letterCount } from '../utils/unicode.js';

export class WordEvolutionManager {
  constructor(familyManager) {
    this.familyManager = familyManager || null;
  }

  /**
   * Compara el tablero al inicio del turno con el tablero confirmado y detecta evoluciones.
   * @param {string[]} prevWords palabras (texto) válidas al inicio del turno
   * @param {string[]} currWords palabras (texto) válidas tras el turno
   * @returns {Array<{from:string, to:string, kind:string}>}
   */
  detectEvolutions(prevWords, currWords) {
    const prevNorm = prevWords.map((w) => normalizeForLookup(w));
    const evolutions = [];

    for (const curr of currWords) {
      const currN = normalizeForLookup(curr);
      // Si la palabra ya existía igual, no es evolución.
      if (prevNorm.includes(currN)) continue;

      // Buscamos una base previa de la que evolucione.
      let best = null;
      for (let i = 0; i < prevWords.length; i++) {
        const base = prevWords[i];
        const baseN = prevNorm[i];
        if (baseN === currN) continue;
        const kind = this._evolutionKind(baseN, currN, base, curr);
        if (kind) {
          // Preferimos la base más larga (evolución más "cercana").
          if (!best || letterCount(base) > letterCount(best.from)) {
            best = { from: base, to: curr, kind };
          }
        }
      }
      if (best) evolutions.push(best);
    }
    return evolutions;
  }

  /** Determina el tipo de evolución entre base y resultado, o null si no lo es. */
  _evolutionKind(baseN, currN, baseDisplay, currDisplay) {
    if (currN.length <= baseN.length) return null;

    // Misma familia lingüística declarada.
    if (this.familyManager && this.familyManager.sameFamily(baseDisplay, currDisplay)) {
      return 'family';
    }
    // Sufijación: CASA -> CASAS, CASA -> CASITA.
    if (currN.startsWith(baseN)) return 'suffix';
    // Prefijación: ORDEN -> DESORDEN, REAL -> IRREAL(aprox).
    if (currN.endsWith(baseN)) return 'prefix';
    // Contiene la raíz (CREAR -> RECREAR): la base aparece dentro.
    if (currN.includes(baseN)) return 'root';
    return null;
  }
}
